// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class MessageContact extends TrackingModel {
	public MessageContactId: number = 0;
	public MessageId: number = 0;
	public ContactId: number = 0;
	public RecipientTypeId: number = 0;
}